"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PREFERRED_SIGNING_ALG = exports.SOLID_CLIENT_AUTHN_KEY_PREFIX = void 0;
exports.SOLID_CLIENT_AUTHN_KEY_PREFIX = "solidClientAuthn:";
exports.PREFERRED_SIGNING_ALG = ["ES256", "RS256"];
//# sourceMappingURL=constant.js.map